import { useRegister } from './reducer/useRegister';
import { HealthAuthorization } from './HealthAuthorization';
import { ZipCodeInput } from './ZipCodeInput';
import { RegisterOtpInput } from './RegisterOtpInput';
import { Navigate } from 'react-router-dom';
import { Routes } from '@xolv-mybrightlink/common';

export const RegisterPage = () => {
  const registerState = useRegister();
  const registerStep = registerState.data.type;

  if (registerStep === 'HEALTH_AUTH') {
    return <HealthAuthorization />;
  } else if (registerStep === 'REQUESTING_REGISTRATION_CODE') {
    return <ZipCodeInput />;
  } else if (registerStep === 'CREATE_ACCOUNT') {
    return <RegisterOtpInput />;
  } else if (registerStep === 'REGISTERED') {
    return <Navigate to={Routes.authenticated} />;
  } else {
    throw new Error('Unknown registration step ' + registerStep);
  }
};
